import React from "react";
import styles from "./ReportsCard.module.css";

const ReportsCard = ({ title, description, onClick }) => {
  return (
    <div className={styles.card} onClick={onClick}>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
    </div>
  );
};

export default ReportsCard;
